import React from 'react';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import { withNamespaces, Trans } from 'react-i18next';

import { ModalTitle, Divider } from 'legacyComponents/styled/lib';
import { Button, Paragraph } from 'components';
import { modalStore } from 'apps/modals/app';
import { Modal } from 'apps/modals/views/modal';

import { ModalContent } from 'apps/modals/styles';

const ButtonStyled = styled(Button)`
  margin: ${props =>
    `${props.theme.spacing.medium} ${props.theme.spacing.small} 0`};
`;

@withNamespaces()
@observer
export class ConfirmAction extends Modal {
  render() {
    return (
      <ConfirmActionNoModal {...this.props} close={modalStore.ClearComponent} />
    );
  }
}

export const ConfirmActionNoModal = withNamespaces()(
  observer(function ConfirmActionNoModal({
    undo,
    text,
    title,
    callBack,
    callBackArgs,
    actionName,
    close,
  }) {
    return (
      <>
        <ModalTitle>
          <Trans>{title}</Trans>
        </ModalTitle>
        <Divider />
        <ModalContent>
          {!undo ? (
            <Paragraph text={text} variant='primary'>
              <Trans>This cannot be undone</Trans>
            </Paragraph>
          ) : (
            text && <Paragraph text={text} variant='primary' />
          )}
          <nav>
            <ButtonStyled
              data-testid='confirm-modal-cancel'
              text={<Trans>Cancel</Trans>}
              variant='secondary'
              size='small'
              onClick={close}
            />
            <ButtonStyled
              data-testid='confirm-modal-ok'
              outline
              text={<Trans>{actionName || 'Delete'}</Trans>}
              size='small'
              onClick={() => {
                callBack(callBackArgs);
                close();
              }}
            />
          </nav>
        </ModalContent>
      </>
    );
  }),
);
